function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.033 3.433c.306-.23.734-.043.793.315l.007.085v16c0 .383-.405.613-.727.446l-.073-.046L10.72 17 6 17c-1.27 0-2.32-.947-2.479-2.174l-.016-.162L3.5 14.5v-5c0-1.325 1.032-2.41 2.336-2.495L6 7l4.278-.001 4.755-3.566zm-.2 1.4l-4.088 3.066c-.065.049-.14.08-.22.094l-.08.006L6 8c-.78 0-1.42.595-1.493 1.356L4.5 9.5v5c0 .78.595 1.42 1.355 1.493L6 16h4.888c.081 0 .16.02.232.056l.068.043 3.645 2.734v-14zm3.95 3.426c1.988 2.238 1.988 5.61 0 7.847-.184.206-.5.225-.707.042-.206-.184-.225-.5-.041-.706 1.652-1.859 1.652-4.66 0-6.518-.184-.207-.165-.523.041-.706.207-.184.523-.165.706.041z"
});

var SvgIconMute = function SvgIconMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-mute.9d726ec5.svg";
export { ForwardRef as ReactComponent };